export const playNotificationSound = () => {
  const audio = new Audio("/assets/audio/notification.mp3");

  audio.play().catch(() => {
    // 🔥 Wait for user interaction (click, scroll, etc.)
    document.addEventListener(
      "click",
      () => {
        audio.play();
      },
      { once: true }
    ); // Only trigger once
  });
};
